export default "__VITE_ASSET__D7xl3uad__"